// @mui
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
// routes
import { RouterLink } from '../router-link';
//
import { BreadcrumbsLinkProps } from './types';

// ----------------------------------------------------------------------

type Props = {
  link: BreadcrumbsLinkProps;
  activeLast?: boolean;
  disabled: boolean;
  id: string;
};

export default function BreadcrumbsLink({ link, id, activeLast, disabled }: Props) {
  const { name, href, icon, state } = link;

  const styles = {
    typography: 'body2',
    alignItems: 'center',
    color: 'text.primary',
    display: 'inline-flex',
    ...(disabled && !activeLast && { cursor: 'default', pointerEvents: 'none', color: 'text.disabled' }),
  };

  const renderContent = (
    <>
      {icon && (
        <Box component="span" sx={{ mr: 1, display: 'inherit', '& svg': { width: 20, height: 20 } }}>
          {icon}
        </Box>
      )}

      {name}
    </>
  );

  if (href) {
    return (
      <Link component={RouterLink} href={href} sx={styles} state={state} id={id}>
        {renderContent}
      </Link>
    );
  }

  return (
    <Box sx={styles} id={id}>
      {' '}
      {renderContent}{' '}
    </Box>
  );
}
